export const EMPLOYEE_TYPE_FILTER_DEFAULT = 'employee';

/** @param {unknown} value */
export function normalizeEmployeeTypeFilter(value) {
  const v = String(value || '').trim().toLowerCase();
  if (v === 'vendor' || v === 'visitor' || v === 'all' || v === 'employee') return v;
  return EMPLOYEE_TYPE_FILTER_DEFAULT;
}

/** @param {'employee' | 'vendor' | 'visitor' | 'all' | string} filter */
export function employeeTypeFilterToIsVendor(filter) {
  const normalized = normalizeEmployeeTypeFilter(filter);
  if (normalized === 'vendor') return true;
  if (normalized === 'employee') return false;
  return null;
}

/** @param {'employee' | 'vendor' | 'visitor' | 'all' | string} filter */
export function employeeTypeFilterToRoleParams(filter) {
  const normalized = normalizeEmployeeTypeFilter(filter);
  if (normalized === 'vendor') return { is_vendor: true, is_visitor: false };
  if (normalized === 'visitor') return { is_vendor: false, is_visitor: true };
  if (normalized === 'employee') return { is_vendor: false, is_visitor: false };
  return { is_vendor: null, is_visitor: null };
}

/** @param {unknown} value */
export function employeeTypeFilterLabel(value) {
  const normalized = normalizeEmployeeTypeFilter(value);
  if (normalized === 'vendor') return 'Vendor';
  if (normalized === 'visitor') return 'Visitor';
  if (normalized === 'all') return 'All';
  return 'Employee';
}

/** @param {unknown} raw */
export function parseEmployeeTypeField(raw) {
  if (raw == null) return null;
  if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) return /** @type {Record<string, unknown>} */ (raw);
  if (typeof raw === 'string') {
    const s = raw.trim();
    if (!s) return null;
    try {
      const p = JSON.parse(s);
      return typeof p === 'object' && p !== null && !Array.isArray(p) ? p : null;
    } catch {
      return null;
    }
  }
  return null;
}

/** @param {unknown} et */
export function snapshotIsVendor(et) {
  const obj = parseEmployeeTypeField(et);
  if (!obj) return false;
  if (obj.is_vendor === true || obj.is_vendor === 'true') return true;
  const t = String(obj.type ?? obj.role ?? '').trim().toLowerCase();
  return t === 'vendor';
}

/** @param {unknown} et */
export function snapshotIsVisitor(et) {
  const obj = parseEmployeeTypeField(et);
  if (!obj) return false;
  if (obj.is_visitor === true || obj.is_visitor === 'true') return true;
  const t = String(obj.type ?? obj.role ?? '').trim().toLowerCase();
  return t === 'visitor';
}

/** @param {unknown} log */
export function logShowsVendorBadge(log, bucketLogs = []) {
  if (!log) return false;
  if (snapshotIsVendor(log.employee_type)) return true;
  return (bucketLogs || []).some((b) => snapshotIsVendor(b?.employee_type));
}

export function logShowsVisitorBadge(log, bucketLogs = []) {
  if (!log) return false;
  if (snapshotIsVisitor(log.employee_type)) return true;
  return (bucketLogs || []).some((b) => snapshotIsVisitor(b?.employee_type));
}

/**
 * @param {unknown} group
 * @param {unknown[]} [timelineEvents] optional loaded timeline rows (may include employee_type before group summary refresh)
 */
export function groupShowsVendorBadge(group, timelineEvents = null) {
  if (!group) return false;
  if (snapshotIsVendor(group.employee_type)) return true;
  const recent = Array.isArray(group.recent_events) ? group.recent_events : [];
  if (recent.some((e) => snapshotIsVendor(e?.employee_type))) return true;
  const te = Array.isArray(timelineEvents) ? timelineEvents : [];
  return te.some((e) => snapshotIsVendor(e?.employee_type));
}

/**
 * @param {unknown} group
 * @param {unknown[]} [timelineEvents] optional loaded timeline rows (may include employee_type before group summary refresh)
 */
export function groupShowsVisitorBadge(group, timelineEvents = null) {
  if (!group) return false;
  if (snapshotIsVisitor(group.employee_type)) return true;
  const recent = Array.isArray(group.recent_events) ? group.recent_events : [];
  if (recent.some((e) => snapshotIsVisitor(e?.employee_type))) return true;
  const te = Array.isArray(timelineEvents) ? timelineEvents : [];
  return te.some((e) => snapshotIsVisitor(e?.employee_type));
}
